define('modules/accounts/security/detail/view',['require','exports','module','jquery','views/BaseView','views/AlertView','ldsh!./template'],function (require, exports, module) {
  "use strict";
  var $ = require("jquery");
  var BaseView = require("views/BaseView");
  var scrollTop = function () {
    $('html,body').scrollTop(0);
  };
  var AlertView = require("views/AlertView");

  var Main = BaseView.extend({
    template: require("ldsh!./template"),
    alertView: null,
    events: {
      "change [name^='isActiveLoginAttemptsLimit']": "showLoginAttemptsLimitOptions",
      "change [name^='isActiveResetPasswordLimit']": "showResetPasswordLimitOptions"
    },
    initialize: function () {
      this.alertView = null;
      this.listenTo(this.model, "reset sync request error", this.render);
    },
    serialize: function () {
      return {
        activeTab: this.activeTab,
        model: this.model, // group,
        group: this.group,
        subTab: this.options.subTab
      };
    },
    afterRender: function () {
      BaseView.prototype.afterRender.call(this);
      if (!this.model.isRequest) {
        this.initForm();
      }
    },
    initForm: function () {
      var self = this;
      $("#messages-container").html("");
      if (self.alertView) {
        $("#messages-container").append(self.alertView.render().el);
      }
      $(".ayuda-context").popover();
      this.setReadOnlyFields();
      $("#form-security-group-detail").bootstrapValidator({
        onSuccess: function (e) {
          self.save();
        },
        onError: function (e) {
          var alertViewError = new AlertView({
            el: "#messages-container",
            type: "danger",
            msg: "ACCOUNTS.COMPANIES.MSG_VALIDATION_ERR"
          });
          alertViewError.render();
          scrollTop();
        },
        fields: {
          loginAttemptsLimit: {
            validators: {
              callback: {
                callback: function (value, validator, $field) {
                  var isActiveLoginAttemptsLimitValue = $('input[name=isActiveLoginAttemptsLimit]:checked').val();
                  if (isActiveLoginAttemptsLimitValue == 'true' && value <= 0)
                    return {
                      valid: false,
                      message: $.i18n.translate("FORM.VALIDATION.TXT_MANDATORY_FIELD")
                    };
                  return true;
                }
              },
            }
          },
          resetPasswordLimitExpirationByDays: {
            validators: {
              callback: {
                callback: function (value, validator, $field) {
                  var isActiveResetPasswordLimit = $('input[name=isActiveResetPasswordLimit]:checked').val();
                  if (isActiveResetPasswordLimit == 'true' && value <= 0)
                    return {
                      valid: false,
                      message: $.i18n.translate("FORM.VALIDATION.TXT_MANDATORY_FIELD")
                    };
                  return true;
                }
              },
            }
          }

        }
      }).on("error.field.bv", function (e, data) {
        var that = $(e.target);
      });
    },
    save: function () {
      var self = this;
      var form = $('#form-security-group-detail');
      var data = {};
      form.serializeArray().map(function (item) {
        data[item.name] = item.value;
      });
      this.model.set(data);
      scrollTop();
      this.model.save(null, {
        success: function (model, response) {
          self.alertView = new AlertView({
            el: "#messages-container",
            type: "success",
            msg: "SECURITY.MSG_FORM_OK"
          });
        },
        error: function (model, response) {
          self.alertView = new AlertView({
            el: "#messages-container",
            type: "danger",
            msg: "SECURITY.MSG_FORM_KO"
          });
          console.log('error', response);
        },
        wait: true
      });

    },
    showLoginAttemptsLimitOptions: function (e) {
      var value = $(e.target).val();
      this.setLoginAttemptsLimitOptions(value);
    },
    showResetPasswordLimitOptions: function (e) {
      var value = $(e.target).val();
      this.setResetPasswordLimitOptions(value);
    },
    setLoginAttemptsLimitOptions: function (value) {
      if (value === 'false') {
        this.setReadOnlyFieldTrue('loginAttemptsLimit');
        this.setReadOnlyFieldTrue('loginAttemptsLimitExpirationByMinutes');
      } else {
        this.setReadOnlyFieldFalse('loginAttemptsLimit');
        this.setReadOnlyFieldFalse('loginAttemptsLimitExpirationByMinutes');
      }
    },
    setResetPasswordLimitOptions: function (value) {
      if (value === 'false') {
        this.setReadOnlyFieldTrue('resetPasswordLimitExpirationByDays');
      } else {
        this.setReadOnlyFieldFalse('resetPasswordLimitExpirationByDays');
      }
    },
    setReadOnlyFieldFalse: function (name) {
      $('#' + name).attr('readonly', false);
      $('#' + name).prop('readonly', false);
      $('#' + name).removeAttr('readonly');
    },
    setReadOnlyFieldTrue: function (name) {
      $('#' + name).attr('readonly', true);
      $('#' + name).prop('readonly', true);
      $('#' + name).attr('readonly', 'readonly');
    },
    setReadOnlyFields: function () {
      var value = $("[name^='isActiveLoginAttemptsLimit']:checked").val();
      this.setLoginAttemptsLimitOptions(value);
      value = $("[name^='isActiveResetPasswordLimit']:checked").val();
      this.setResetPasswordLimitOptions(value);
    }
  });

  module.exports = Main;
});

